import { render, staticRenderFns } from "./SkillEditor.vue?vue&type=template&id=355daae7&"
import script from "./SkillEditor.vue?vue&type=script&lang=js&"
export * from "./SkillEditor.vue?vue&type=script&lang=js&"
import style0 from "./SkillEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverflowBtn } from 'vuetify/lib/components/VOverflowBtn';
installComponents(component, {VBtn,VCardTitle,VDataTable,VIcon,VOverflowBtn})
